import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTaxAndAccountingOnboarding } from './tax-and-accounting-onboarding.types';

type UseTaxAndAccountingOnboardingResponse = {
  taxAndAccountingOnboarding: TTaxAndAccountingOnboarding;
};

function useTaxAndAccountingOnboarding(
  corporationId: number | null,
  fiscalYear: number | null
) {
  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data: UseTaxAndAccountingOnboardingResponse | undefined;
    error: Error | undefined;
    mutate: KeyedMutator<UseTaxAndAccountingOnboardingResponse>;
    isLoading: boolean;
  } = useSWR(
    corporationId && fiscalYear
      ? `tax-and-accounting-onboarding?corporationId=${corporationId}&fiscalYear=${fiscalYear}`
      : null,
    SWRFetcher({ method: 'GET' }),
    { shouldRetryOnError: false }
  );

  return {
    data: data?.taxAndAccountingOnboarding,
    error,
    mutate,
    isLoading: isLoading ?? false,
  };
}

export { useTaxAndAccountingOnboarding };
